import {Component, EventEmitter, Input, Output} from '@angular/core';
import {importStepperConfig} from '../../configs/import-stepper/import-stepper.config';
import {StepperReadyEvent} from '../../../stepper/events/stepper-ready.event';
import {ImportConfig} from '../../configs/import.config';
import {StepperConfig} from '../../../stepper/stepper.config';

@Component({
    selector: 'mydocma-import-stepper',
    templateUrl: './import-stepper.component.html',
    styleUrls: ['./import-stepper.component.scss']
})
export class ImportStepperComponent {

    @Input()
    public fieldsToImportConfig: ImportConfig;

    @Output()
    public ready = new EventEmitter<StepperReadyEvent>();

    @Output()
    public importEvent = new EventEmitter();

    public stepperConfig: StepperConfig = importStepperConfig;

    public stepperData: StepperReadyEvent;

    public onReadyEvent(param: StepperReadyEvent) {
        this.stepperData = param;

        this.stepperConfig.validate = (currStep) => {
            if (currStep.index >= 2) {
                return;
            }

            this.stepperData.executionService.end();

            const step = this.stepperData.stepperService.getStepByIndex(currStep.index + 1);
            if (!step.completed) {
                return;
            }

            this.setStepData(step, {error: null, valid: false, data: null});
        };

        this.ready.emit(param);
    }

    public onImportEvent() {
        this.importEvent.emit();
    }

    private setStepData(step, stepData) {
        this.stepperData.stepperService.setStepData(step, stepData, false);

        if (step.index < 3) {
            const stepByIndex = this.stepperData.stepperService.getStepByIndex(step.index + 1);
            this.setStepData(stepByIndex, {error: null, valid: false, data: null});
        }
    }
}

